import React from 'react'
import './Header.css';

const Header = () => {
    return (
        <div className= "header-asistencias-prefectos">
            <div className= "titulo-asistencias-prefectos">
                <h2>
                    Consulta de Retardos de los Alumnos
                </h2>
                <p>
                    Consulta los retardos de los alumnos.
                </p>
            </div>
        </div>
    );
};

export default Header;